export default {
  initDataLoaded(s) {
    return s.categoryNames !== null;
  },
  categoryNames(s) {
    return s.categoryNames;
  },
  typeaheadResults(s) {
    return s.typeaheadResults;
  },
  authenticated(s) {
    return s.authenticated;
  },
  user(s) {
    return s.user;
  },
  locale(s) {
    return s.locale;
  },
  notify(s) {
    return s.notify;
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js